import { apolloAGGCache } from '../src/getAGGClient.ts';
import type { BroadcastConfigurableInMemoryCache } from './createClient.ts';

export { getAGGClient } from '../src/getAGGClient.ts';

export function getApolloAGGCache(): BroadcastConfigurableInMemoryCache {
	return apolloAGGCache;
}
